import { Component } from '@angular/core'
import { select, Store } from '@ngrx/store'
import * as UserActions from 'src/app/store/user/actions'
import * as Reducers from 'src/app/store/reducers'
import { Router } from '@angular/router'

@Component({
  selector: 'vb-menu-simply-user-menu',
  templateUrl: './user-menu.component.html',
  styleUrls: ['./user-menu.component.scss'],
})
export class MenuSimplyUserMenuComponent {
  name: string = ''
  role: string = ''
  email: string = ''
  phone: string = ''

  constructor(private store: Store<any>, private router: Router) {
    this.store.pipe(select(Reducers.getUser)).subscribe((state) => {
      this.name = state.name
      this.role = state.roleName
      this.email = state.email
    })
  }

  logout() {
    this.store.dispatch(new UserActions.Logout())
  }
  editProfile() {
    this.router.navigate(['/user-profile'])
  }
}
